import { loadCatalogSchemes } from "src/business/catalog/apiCatalog";
import { ZCatalog } from "src/business/catalog/ZCatalog";
import { ZCatalogRecord } from "src/business/records/ZCatalogRecord";

import { CDSFormStoreLoader } from "./CDSFormStore";
import { createCatalogSchemesByClassesLoader } from "./createCatalogSchemesByClassesLoader";
import { extractClassIdsFromFieldsValue } from "./extractClassIdsFromFieldsValue";
import { extractClassIdsFromRecord } from "./extractClassIdsFromRecord";
import { makeRecordForm } from "./makeRecordForm";
import { mergeUniqueSchemes } from "./mergeUniqueSchemes";

export type CatalogRecordFormContext = {
  record?: ZCatalogRecord;
};

export const createCatalogRecordFormLoader = (
  catalog: ZCatalog,
): CDSFormStoreLoader<CatalogRecordFormContext> => {
  const loadCatalogSchemesByClassesCached = createCatalogSchemesByClassesLoader(
    catalog.id,
  );
  return {
    async load({ record }, currentValues) {
      const classIds = currentValues
        ? extractClassIdsFromFieldsValue(
            currentValues as Record<string, unknown>,
          )
        : extractClassIdsFromRecord(record);
      const [allSchemes, clsSchemes] = await Promise.all([
        loadCatalogSchemes(catalog.id),
        loadCatalogSchemesByClassesCached(classIds),
      ]);
      const schemes = mergeUniqueSchemes([...allSchemes, ...clsSchemes]);
      return {
        info: makeRecordForm(schemes, catalog.classifiers ?? [], record),
        schemes,
        errors: record?.errors ?? undefined,
      };
    },
  };
};
